import { c } from '../../../utils/tailwind-merge';
import { ButtonV2 } from '../../atoms/Button/Button.v2';
import { ReviewBars } from '../../molecules/ReviewBars';
import { ReviewStars } from '../../molecules/ReviewStars';
import { ProductRatingProps } from './ProductRating.types';

export const ProductRating = ({
  reviewStars,
  canWriteReview,
  overall,
  writeReview,
  microcopy,
  onFilterReviews,
  onWriteReview,
  reviews,
  reviewList,
  className,
}: ProductRatingProps) => {
  return (
    <div className={c(className)}>
      <p className="text-md font-medium tracking-[-0.108px] text-grey-900">
        {overall}
      </p>
      <div className="my-8 flex flex-col md:my-6 md:flex-row">
        <ReviewStars
          value={reviewStars.value}
          max={5}
          reviews={reviewStars.reviews}
          microcopy={{
            reviews,
            ariaLabel: microcopy.ariaLabel,
          }}
          variant={'large'}
        />
        <div className="mt-8 flex w-full justify-center md:mt-0">
          <ReviewBars
            microcopy={{
              rating: microcopy.rating,
              ratings: microcopy.ratings,
              ratingAriaLabel: microcopy.ratingAriaLabel,
              ariaLabel: microcopy.ariaLabel,
            }}
            reviewList={reviewList}
            className="w-80 md:w-[396px]"
            onFilterReviews={onFilterReviews}
          />
        </div>
      </div>
      {canWriteReview && (
        <ButtonV2
          shape="square"
          onClick={onWriteReview}
          label={writeReview}
          className="mb-8 w-full md:mb-0 md:w-auto"
        />
      )}
    </div>
  );
};
